<div class="error-state" role="status">
  <span aria-hidden="true" class="error-state__icon material-symbols-outlined">
    {{ state().icon }}
  </span>
  <h1 class="error-state__title">{{ state().title | transloco }}</h1>
  <p class="error-state__body">{{ state().body | transloco }}</p>
  @if (state().canRetry) {
    <div class="error-state__action">
      <p-button
        [label]="'ERRORS.TRY_AGAIN' | transloco"
        (onClick)="onRetry()" />
    </div>
  }
</div>
